import { FaInstagram, FaFacebook } from "react-icons/fa6";
import { CiMail } from "react-icons/ci";

export default function Footer() {
  return (
    <footer className="bg-cream py-6 font-garet text-sm">
    <div className="flex flex-col sm:flex-row items-center justify-between max-w-5xl mx-auto px-4">
      <p className="mb-4 sm:mb-0">&copy; 2025 Girls Club Teesside. All rights reserved.</p>
      <div className="flex space-x-4 text-xl">
        <a href="https://www.instagram.com/girls_club_teesside/" target='_blank' rel="noreferrer">
        <FaInstagram />
        </a>
        <a href="https://www.facebook.com/groups/360266296904255/" target='_blank' rel="noreferrer">
        <FaFacebook />
        </a>
        <a href="mailto:girls_club_teesside@hotmail.co.uk">
        <CiMail />
        </a>
      </div>
    </div>
  </footer>
  );
}
